(function () {
  $(document).ready(() => {
    $(".video").fitVids();
  });
})();
